import { DCRecord, IDataController } from "@/@types/lib/dataController";
import { Box, Button, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

type RadniSastanciCommentBlockProps = {
    selectedRecord: DCRecord | null;
    onSave: (text: string) => void;
}

const RadniSastanciCommentBlock = (props: RadniSastanciCommentBlockProps) => {
    const { selectedRecord, onSave } = props;

    const [ initialCommentState, setInitialCommentState ] = useState<string>(selectedRecord?.komentar ? selectedRecord?.komentar?.toString() : '');
    const [ commentState, setCommentState ] = useState<string>(initialCommentState);
    const [ commentChanged, setCommentChanged ] = useState<boolean>(false);

    const onCancel = (() => {
        setCommentState(initialCommentState);
    });

    const onCommentChange = ((e: any) => {
        if(e?.target?.value !== initialCommentState) {
            setCommentChanged(true);
        } else {
            setCommentChanged(false)
        }
        setCommentState(e?.target?.value);
    });

    const handleSave = (() => {
        onSave(commentState);
        setInitialCommentState(commentState);
        setCommentChanged(false);
    });

    useEffect(() => {
        setInitialCommentState(selectedRecord?.komentar ? selectedRecord?.komentar?.toString() : '');
        setCommentState(selectedRecord?.komentar ? selectedRecord?.komentar?.toString() : '');
    }, [selectedRecord]);

    return (
        <Box>
            <TextField id="outlined-basic" label="Komentar" variant="outlined" fullWidth 
                onChange={onCommentChange} value={commentState} onKeyDown={(event: any) => {event.key == 'Enter' ? handleSave() : null}}>
            </TextField>
            <br></br>
            <br></br>
            <Button variant="outlined" size="small"  onClick={onCancel} sx={{marginRight: "10px"}}>Poništi promjene</Button>
            <Button variant="contained" size="small" onClick={() => {handleSave()}} disabled={commentChanged === true ? false : true}>Spremi</Button>
        </Box>
    );
}

export default RadniSastanciCommentBlock;